/**
 * Helper for pretty console outputs
 * also consider following info:
 *   - use Command + K to clear console
 *   - look up all console functions in the console by typing "console"
 * https://www.youtube.com/watch?v=sXT5DkeZnrA for more info
 */
class ConsoleHelper {
    /* eslint-disable no-console */
    /**
     * print s&f agency info in console
     */
    static printAgency() {
        const company = '%cschalk&friends';
        const companyLink = '%chttps://www.schalk-and-friends.de';

        // eslint-disable-next-line max-len
        const encodedCompanyLogo = '"data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\' viewBox=\'0 0 100 100\'%3E%3Cpath d=\'M0 0v100h100V0H0z\'/%3E%3Cpath fill=\'%23fff\' d=\'M65.4 66.4l13.1-15.2H63.6l-6.4 7.4-8.1-6.7c-3.9-3.5-6.7-6-8.5-7.4 0 0-2.5-2.5-4.2-4.9-.7-1.1-1.1-2.8-.7-4.6.4-1.4 1.1-4.2 5.3-5.3 1.4-.4 3.2-.7 5.3 0 2.8.7 7.1 4.2 10.2 7.8l8.1-6.7s-4.6-5.3-9.2-8.1c-3.9-2.5-7.8-3.5-12.4-3.5-3.5 0-6 .7-8.8 2.1s-5.7 3.9-7.1 6.4c-1.8 2.5-2.5 5.7-2.5 8.8 0 2.5.4 4.6 1.4 6.7.7 1.4 2.8 4.2 2.8 4.2-2.8 2.5-5.7 5.7-6.4 7.4-2.1 3.5-2.8 7.4-2.1 11.3.7 3.5 2.1 6.7 4.2 9.2 2.1 2.5 5.3 4.2 8.8 5.3s7.1 1.1 11.3.7c5.3-.7 9.9-2.8 13.8-6.4l5.7 4.9h16.3c.2.1-15-13.4-15-13.4zm-17.3 1.8c-1.8 1.4-3.5 2.5-6 2.8-1.8.4-3.5 0-4.9-.4-1.4-.4-2.8-1.4-3.9-2.5s-1.8-2.5-1.8-3.9c-.4-1.8 0-3.5 1.1-4.9.4-.7 1.8-2.1 2.8-3.2l1.1-1.1 13.1 11.7-1.5 1.5z\'/%3E%3C/svg%3E%0A"';

        console.info(
            `%c ${company} ${companyLink}`,
            `padding-left: 36px; background-image: url(${encodedCompanyLogo}); background-size: 32px; 
                background-repeat: no-repeat; background-position: 2px 2px; line-height: 36px;`,
            'background: #666; border-radius:0.5em; padding:0.2em 0em 0.2em 0.5em; color: white; font-weight: bold;',
            'padding:0.2em 0em 0.1em 0.5em;text-transform: uppercase;',
        );
    }

    /**
     * print different infos
     *   - strings, e.g. ConsoleHelper.printLog('test');
     *   - objects, e.g. ConsoleHelper.printLog({ key1: 'value1', key2: 'value2' }, 'mycustomdebug');
     * @param info
     * @param name
     */
    static printLog(info, name = 'Debug') {
        const styleDebug = `
            color: black; 
            background-color: yellow; 
            border-radius: 0.5em; 
            padding-block: 0.2rem;
            padding-inline: 0.5rem;
        `;

        if (typeof info === 'object' && info !== null) {
            console.log(`%cDEBUG%c ${name} group`, styleDebug, '');
            console.groupCollapsed(name);
            Object.keys(info).forEach((key) => {
                    console.log(`${key}: ${info[key]}`);
            });
            console.groupEnd();

            return;
        }
        console.log(`%cDEBUG%c ${info}`, styleDebug, '');
    }
    /* eslint-enable no-console */
}

export default ConsoleHelper;
